import moment from 'moment';

export { alarm };

const alarm = () => {
  return [
    {
      label: 'Summary',
      icon: 'dashboard',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'totalIncidents', header: 'Total' },
          { field: 'geoIncident', header: 'POI' },
          { field: 'batteryIncident', header: 'Backup Battery' },
          { field: 'uiIncident', header: 'Unauthorized Ignition' },
          { field: 'harshBrakeIncident', header: 'Harsh Braking' },
          { field: 'immoIncident', header: 'Immobilizer' },
          { field: 'speedingIncident', header: 'Overspeeding' },
          { field: 'idlingIncident', header: 'Idling' },
        ],
      },
      pdf: {
        title: 'Alarm - Summary',
        colsWidth: [101, 43, 40, 40, 70, 70, 70, 70, 60],
      },
    },
    {
      label: 'Breakdown',
      icon: 'event',
      view: {
        type: 'table',
        content: [
          { field: 'assetName', header: 'Asset' },
          { field: 'time', header: 'Time' },
          { field: 'type', header: 'Type' },
          { field: 'details', header: 'Duration' },
          { field: 'details2', header: 'Details' },
          { field: 'address', header: 'Location' },
          {
            header: 'Actions',
            template: {
              component: 'ActionButtons',
              data: [
                {
                  text: getText,
                  icon: 'icon-map',
                  iconPack: 'feather',
                  color: getColor,
                  click: {
                    component: 'PlayBack',
                    data: { onReady: getPlayback },
                    disable: disableClick,
                  },
                },
              ],
            },
          },
        ],
      },
      pdf: {
        title: 'Alarm - Breakdown',
        colsWidth: [101, 100, 80, 100, 150],
      },
    },
  ];
};
const getText = (self) => {
  if (self.type == 'Overspeeding') {
    return 'View Overspeeding Playback';
  } else {
    return 'Playback only for Overspeeding';
  }
};

const getColor = (self) => {
  if (self.type == 'Overspeeding') {
    return 'primary';
  } else {
    return 'grey';
  }
};
const disableClick = (self) => {
  if (self.type !== 'Overspeeding') {
    return true;
  } else {
    return false;
  }
};

const tripTimerange = (tripTime) => {
  const time = tripTime.split('-');
  const timeRange = [0, 0];
  time[0] = time[0].substring(0, time[0].length);
  time[1] = time[1].substring(1, time[1].length);
  timeRange[0] = moment(time[0], 'DD/MM/YYYY | hh:mm:ss').toISOString();
  timeRange[1] = moment(time[1], 'DD/MM/YYYY | hh:mm:ss').toISOString();
  return { timeRange, time };
};
const getPlayback = (self) => {
  let args = self.data.rowData;
  return new Promise((resolve) => {
    self.isLoading = true;
    const time = args.time.split('-');
    const timeRange = [0, 0];
    time[0] = time[0].substring(0, time[0].length - 1);
    time[1] = time[1].substring(1, time[1].length);
    timeRange[0] = moment(time[0], 'DD/MM/YYYY | hh:mm:ss').toISOString();
    timeRange[1] = moment(time[1], 'DD/MM/YYYY | hh:mm:ss').toISOString();
    self.$http
      .post(`singleUnitPlayback/${args.assetId}/${self.userInfo.uid}`, {
        timeRange,
        geoPOIData: self.geoPOIData,
        configuration: self.configuration,
        type: ['Moving', 'Idling', 'Parked'],
        mode: 1,
      })
      .then(function (response) {
        if (response.status == 200 && response.data.success) {
          self.selected.routeArray = response.data.routeArray;
          self.selected.routePath = response.data.routePath;
          self.selected.assetName = args.assetName;
          self.popupActive = true;
          self.isLoading = false;
          self.loadMap = true;
          self.onReadyData.title = `Overspeeding - ${args.assetName}`;
          self.selected.timeRange = tripTimerange(args.time).timeRange;
          self.exportZoom = 0;
          resolve(true);
        } else {
          self.isLoading = false;
          if (response.data.error) {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          } else {
            self.$vs.notify({
              title: 'Error',
              text: 'Try again later.',
              iconPack: 'feather',
              icon: 'icon-alert-circle',
              color: 'warning',
            });
            resolve(false);
          }
        }
      })
      .catch(function (error) {
        console.log(error);
        self.isLoading = false;

        self.$vs.notify({
          title: 'Error',
          text: 'Try again later.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'warning',
        });
        resolve(false);
      });
  });
};
